"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var classNames = require("classnames");
var ReactDOM = require("react-dom");
var bind_1 = require("../bind");
var react_router_1 = require("react-router");
var MOUSEOUT_BUFFER_MS = 600;
var HeaderDropdown = /** @class */ (function (_super) {
    tslib_1.__extends(HeaderDropdown, _super);
    function HeaderDropdown() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isOpen: false,
        };
        return _this;
    }
    HeaderDropdown.prototype.didClickPage = function (evt) {
        if (ReactDOM.findDOMNode(this).contains(evt.target))
            return;
        this.closeDropdown();
    };
    HeaderDropdown.prototype.componentDidUpdate = function (prevProps) {
        if (!this.props.activeDropdownKey)
            return null;
        if (prevProps.activeDropdownKey === this.props.activeDropdownKey)
            return null;
        if (this.props.dropdownKey === this.props.activeDropdownKey)
            return null;
        this.closeDropdown();
    };
    HeaderDropdown.prototype.openDropdown = function () {
        this.setState({ isOpen: true });
        this.bindPageClickEvent();
        this.props.onOpen(this.props.dropdownKey);
    };
    HeaderDropdown.prototype.closeDropdown = function () {
        this.unbindPageClickEvent();
        this.setState({ isOpen: false });
    };
    HeaderDropdown.prototype.bufferedClose = function () {
        var _this = this;
        window.clearTimeout(this.timeoutId);
        this.timeoutId = window.setTimeout(function () {
            _this.shouldClose() && _this.closeDropdown();
        }, MOUSEOUT_BUFFER_MS);
    };
    HeaderDropdown.prototype.toggleDropdown = function (evt) {
        evt.preventDefault();
        !this.state.isOpen && this.openDropdown();
        this.state.isOpen && this.closeDropdown();
    };
    HeaderDropdown.prototype.handleTriggerClick = function (e) {
        // possible for touch devices to keep the trigger focused,
        // so we check state.isOpen to make sure the dropdown is open
        // before they visit the link.
        // also, if they tap after scrolling (which doesn't remove focus),
        // we reopen the modal
        if (this.state.isOpen && this.props.triggerUrl)
            return true;
        e.preventDefault();
        !this.state.isOpen && this.openDropdown();
    };
    HeaderDropdown.prototype.shouldClose = function () {
        return !ReactDOM.findDOMNode(this).querySelector(':hover');
    };
    HeaderDropdown.prototype.unbindPageClickEvent = function () {
        document.removeEventListener('touchstart', this.didClickPage);
    };
    HeaderDropdown.prototype.bindPageClickEvent = function () {
        document.addEventListener('touchstart', this.didClickPage);
    };
    HeaderDropdown.prototype.renderTrigger = function () {
        if (this.props.triggerUrl) {
            return (React.createElement(react_router_1.Link, { className: "header-dropdown__trigger", onFocus: this.openDropdown, onClick: this.handleTriggerClick, to: this.props.triggerUrl }, this.props.trigger));
        }
        return (React.createElement("div", { className: "header-dropdown__trigger", onFocus: this.openDropdown, onClick: this.handleTriggerClick }, this.props.trigger));
    };
    HeaderDropdown.prototype.render = function () {
        var classes = classNames('header-dropdown', { 'header-dropdown--open': this.state.isOpen });
        return (React.createElement("div", { className: classes, onMouseOver: this.openDropdown, onFocus: this.openDropdown, onMouseOut: this.bufferedClose, onBlur: this.bufferedClose },
            this.renderTrigger(),
            React.createElement("div", { className: "header-dropdown__contents", onClick: this.closeDropdown }, this.props.contents)));
    };
    tslib_1.__decorate([
        bind_1.default
    ], HeaderDropdown.prototype, "didClickPage", null);
    tslib_1.__decorate([
        bind_1.default
    ], HeaderDropdown.prototype, "openDropdown", null);
    tslib_1.__decorate([
        bind_1.default
    ], HeaderDropdown.prototype, "closeDropdown", null);
    tslib_1.__decorate([
        bind_1.default
    ], HeaderDropdown.prototype, "bufferedClose", null);
    tslib_1.__decorate([
        bind_1.default
    ], HeaderDropdown.prototype, "toggleDropdown", null);
    tslib_1.__decorate([
        bind_1.default
    ], HeaderDropdown.prototype, "handleTriggerClick", null);
    return HeaderDropdown;
}(React.Component));
exports.default = HeaderDropdown;
//# sourceMappingURL=header_dropdown.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/components/header_dropdown.js
// module id = FCZ9
// module chunks = 20 21